// CÓDIGO FINAL E CORRIGIDO para: src/db.js

import { openDB } from 'idb';

const DB_NAME = 'dengue-app-db';
const STORE_NAME = 'visitas_pendentes';
const DB_VERSION = 1;

/**
 * Adiciona um objeto de visita na fila do IndexedDB.
 * A cada chamada, esta função abre uma nova conexão, garantindo que ela
 * não entre em conflito com o ciclo de vida do Service Worker.
 * @param {object} visitaData - Os dados da visita a serem salvos.
 */
export const adicionarVisitaNaFila = async (visitaData) => {
  // Abre uma conexão NOVA e limpa a cada chamada
  const db = await openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      // A lógica para criar a "tabela" (object store) continua aqui,
      // garantindo que ela exista.
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'id', autoIncrement: true });
      }
    },
  });

  // Adiciona os dados na "tabela" (object store)
  await db.add(STORE_NAME, visitaData);

  // A biblioteca 'idb' gerencia o fechamento da conexão automaticamente
  // após a transação ser concluída.
};

/**
 * Recupera todas as visitas pendentes na fila do IndexedDB.
 * @returns {Promise<Array>} Uma lista com os objetos de visita.
 */
export const getVisitasNaFila = async () => {
  const db = await openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'id', autoIncrement: true });
      }
    },
  });

  return await db.getAll(STORE_NAME);
};